import { WhatsAppOutlined } from '@ant-design/icons'
import { Button, Image } from 'antd'
import React from 'react'
import { dataUser } from '../../../services/Cache/Auth'

function StepStatusBayar(pr) {

    const dt = pr.dataOrder
    const followUp = () => {
        var msg = " Mohon konfirmasi pembayaran Nomor : " + dt.kodeorderkonseling + " an. " + dataUser.login.namapembeli + " Tanggal :  " + dt.tgl
        window.open("https://wa.me/6287865343583?text=" + msg, "_blank")
    }


    return (
        <center>

            {pr.verifikasi == "KPK" ?
                <div>
                    <img style={{ borderRadius: "10px" }} width={400} src="/img/verif.png" alt="image" />
                    <h3 className='mt-3'> <b> Berhasill ... </b> </h3>
                </div> :
                <div>
                    <img style={{ borderRadius: "10px" }} width={300} src="/img/waiting.gif" alt="image" />
                    <h3 className='mt-3'> <b>
                        Menunggu Verifikasi Pembayaran<br />Oleh Ahli gizi RSUD H. Moh. Ruslan </b> </h3>
                    <Button icon={<WhatsAppOutlined />} onClick={followUp} size='large' > Follow Up </Button>
                </div>
            }
            {/* <h3> Bukti Pembayaran </h3>
            <Image
                width={100}
                className='rounded'
                src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
            /> */}
            <hr />
        </center>
    )
}

export default StepStatusBayar